<template>
  <div>
    <el-steps :active="active" align-center finish-status="success" style="margin-bottom: 15px">
      <el-step title="Selecionar colunas"></el-step>
      <el-step title="Importar Planilha"></el-step>
      <el-step title="Resultado"></el-step>
    </el-steps>

    <el-card shadow="always">
      <div>
        <el-form ref="form" :model="importForm" label-width="160px" v-if="active === 0">
          <el-row :gutter="5" v-if="!isCustomer">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item :label="$t('cliente')" prop="customer">
                <CustomerList v-model="importForm.customer" :customer="customer" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
              <el-form-item :label="$t('usar')" prop="use">
                <el-select ref="user" v-model="importForm.use" placeholder="Selecione  uma opção" clearable>
                  <el-option key="1" label="Separador" value="1"></el-option>
                  <el-option key="2" label="Tamanho Fixo" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
              <el-form-item :label="$t('meus-layouts')" prop="layout">
                <el-select ref="user" v-model="importForm.layout" placeholder="Selecione uma opção" clearable
                  @change="setup()">
                  <el-option v-for="layout in importForm.layouts" :key="layout.id" :label="layout.name"
                    :value="layout.name">
                    <!--span style="float: left">{{ layout.name }}</!--span>
                    <span-- style="float: right"
                      ><el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="mini"
                      ></el-button
                    ></span-->
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
              <el-form-item label="Contém cabeçalho" prop="header">
                <el-radio v-model="importForm.header" label="1">Sim</el-radio>
                <el-radio v-model="importForm.header" label="2">Não</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <br />
        <el-row v-if="active === 1" class="uploadWrapper" :gutter="5">
          <el-col>
            <el-upload class="upload-demo" drag action="/api/import/upload/" :multiple="false" :limit="1" ref="file"
              :file-list="fileList" :on-success="uploadAndCompare" :style="hasError ? 'width: 60%' : ''" :on-remove="() => {
                isEqual = false;
                hasFile = false;
                hasError = false;
                error.values = [];
                mandatoryColumns = [];
                fileFields = '';
              }
                ">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Arraste o arquivo ou <em>clique para aqui para enviar</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                Arquivos csv/txt com a listagem de pre-postagens
              </div>
            </el-upload>
          </el-col>
          <el-col v-if="hasError">
            <el-card class="errorReport">
              <span>{{ error.error ? error.error : "" }}</span>
              <div class="reportTable">
                <el-table :data="error.values" style="width: 100%" height="150" v-if="mandatoryColumns.length === 0 || error.values.length > 0
                  ">
                  <el-table-column prop="pos" label="Coluna" width="100">
                  </el-table-column>
                  <el-table-column prop="file" label="No Layout" width="180">
                  </el-table-column>
                  <el-table-column prop="layout" label="No Arquivo" width="180">
                  </el-table-column>
                </el-table>

                <el-table :data="mandatoryColumns" style="width: 100%" height="150" v-if="mandatoryColumns.length > 0 && error.values.length === 0
                  ">
                  <el-table-column prop="col" label="Coluna" width="460" align="center">
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <Resulting v-if="active === 2" :records="prepostList" />

        <el-transfer v-if="active === 0" filterable :filter-method="filterMethod" filter-placeholder="Campos"
          v-model="value" target-order="push" :titles="['Disponiveis', 'Selecionados']" :data="tableData">
          <el-button class="transfer-footer" slot="right-footer" size="small" type="warning" @click="save()">Salvar
            Layout</el-button>
        </el-transfer>

        <el-row :gutter="5" style="margin-top: 50px">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="6" :offset="11" style="display: flex; justify-content: center">
            <el-button v-if="active > 0" @click="back()">Voltar</el-button>
            <el-button v-if="active < 1" type="primary" @click="next()" :disabled="(value.length === 0 && !importForm.use) || !importForm.customer
              ">Prosseguir</el-button>
            <el-button v-if="active == 1" type="warning" ref="finish" @click="finish()"
              :disabled="!hasFile">Finalizar</el-button>
            <el-tooltip v-if="active != 1" class="item" effect="dark"
              content="Clique para baixar uma Planilha de Exemplo." placement="top">
              <el-button type="text" icon="el-icon-info" style="color: black" @click="downloadSample()"></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="active === 0">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-table size="mini" :data="tableData.filter((x) => x.description)" style="width: 100%">
              <el-table-column prop="label"></el-table-column>
              <el-table-column prop="description"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { CustomerService } from "@/services/customers/customers.services";
import { LayoutService } from "@/services/customers/layout.services";
import { UploadService } from "@/services/customers/upload.services";
import { PostOfficeService } from "@/services/post.office/post.office.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import DepartmentList from "@/xpost/views/register/department/DepartmentList.vue";
import Resulting from "./prepost/Resulting.vue";


export default {
  name: "ImportPrepost",
  props: ["state"],
  components: {
    DepartmentList,
    CustomerList,
    Resulting,
  },
  props: ["type"],
  methods: {
    setup() {
      const vm = this;
      if (!vm.importForm.layout) {
        return false;
      }
      const layout = vm.importForm.layouts.find(
        (x) => x.name === vm.importForm.layout
      );
      if (layout && layout.fields) {
        vm.value = layout.fields.split(",");
      }
    },
    async uploadAndCompare() {
      const vm = this;
      const file = vm.$refs.file.uploadFiles[0].raw;
      if (file) {
        vm.hasFile = true;
      }
      vm.fileData = [];
      const fileData = new FormData();
      fileData.append("file", file);
      const fileResponse = await UploadService.upload(fileData);
      if (vm.dataAnalyze(fileResponse)) {
        vm.createPrepost(fileResponse);
      }
    },

    dataAnalyze(file) {
      const vm = this;
      vm.fileFields = Object.keys(file[0]);

      if (vm.importForm.fields.length === vm.fileFields.length) {
        vm.mandatoryProperties.forEach((prop) => {
          if (!file[0].hasOwnProperty(prop)) {
            vm.error.error = "Colunas obrigatórias não foram enviadas";
            vm.mandatoryColumns.push({
              col: prop,
            });

            vm.hasError = true;
          } else if (!vm.importForm.fields.includes(prop)) {
            vm.mandatoryColumns.push({
              col: prop,
            });

            vm.hasError = true;
          }
        });

        if (vm.hasError) {
          this.$message({
            type: "error",
            message:
              vm.error.error + " Colunas: " + vm.mandatoryColumns.join(", "),
          });
          return;
        }

        this.$message({
          type: "success",
          message: "Arquivo compatível.",
        });

        const fileFields = Object.keys(file[0]);
        for (const row of file) {
          const record = {};
          vm.importForm.fields.forEach((field, index) => {
            record[field] = row[fileFields[index]];
          });
          vm.fileData.push(record);
        }

        vm.isEqual = true;
        vm.error = {
          error: "",
          values: [],
        };

        return true;
      } else {
        vm.error.error = `
        Quantidade de Colunas incompatíveis.
        LAYOUT: ${vm.importForm.fields.length},
        ARQUIVO: ${vm.fileFields.length}`;
        this.$message({
          type: "error",
          message: vm.error.error,
        });
        vm.isEqual = false;

        return false;
      }
    },

    async createPrepost() {
      const vm = this;

      const analyze = vm.fileData.map(async (data, index) => {
        await vm.setPrepostData(data, index);
        return true;
      });

      Promise.all(analyze).then((response) => {
        if (response.includes(false)) {
          this.$message({
            type: "error",
            message: vm.error.error,
          });
        }
      });
    },

    setPrepostData(data, index) {
      const vm = this;
      let prepostData = {
        prepost: {
          cardpost: "",
          customer: "",
          service: "",
          sender: {},
          delivery: {},
          contact: {},
          object: {},
          complement: {},
        },
      };

      if (data.CARTAO) {
        CustomerService.customerCardpost(vm.importForm.customer, data.CARTAO)
          .then((response) => {
            prepostData.prepost.cardpost = response.code;
          })
          .catch((err) => {
            prepostData.error = {
              error: err,
            };
          });
      } else {
        CustomerService.cardpost(vm.importForm.customer).then((response) => {
          prepostData.prepost.cardpost = response.code;
        });
      }

      if (data.CEP_REM && data.CEP_REM.length < 8) {
        data.CEP_REM = data.CEP_REM.padStart(8, "0");
      }

      if (data.CEP_REM) {
        PostOfficeService.zipcode(data.CEP_REM)
          .then((res) => {
            if (res) {
              prepostData.prepost.sender = {
                cep: res.cep,
                contact: data.NOME_REM ? data.NOME_REM : "",
                address: data.ENDERECO_REM ? data.ENDERECO_REM : res.end,
                neighborhood: data.BAIRRO_REM ? data.BAIRRO_REM : res.bairro,
                city: data.CIDADE_REM ? data.CIDADE_REM : res.cidade,
                state: data.UF_REM ? data.UF_REM : res.uf,
                number: data.NUMERO_REM ? data.NUMERO_REM : "",
                extent: data.COMPLEMENTO_REM ? data.COMPLEMENTO_REM : "",
              };
            }
          })
          .catch((err) => {
            prepostData.error = {
              error: err,
            };
          });
      } else {
        CustomerService.get(vm.importForm.customer).then((response) => {
          if (response) {
            prepostData.prepost.sender = {
              cep: response.zipcode.zipcode,
              contact: data.NOME_REM ? data.NOME_REM : response.name,
              address: data.ENDERECO_REM ? data.ENDERECO_REM : response.zipcode.address,
              neighborhood: data.BAIRRO_REM ? data.BAIRRO_REM : response.zipcode.neighborhood,
              city: data.CIDADE_REM ? data.CIDADE_REM : response.zipcode.city,
              state: data.UF_REM ? data.UF_REM : response.zipcode.state,
              number: data.NUMERO_REM ? data.NUMERO_REM : response.number,
              extent: data.COMPLEMENTO_REM ? data.COMPLEMENTO_REM : response.extent,
            };
          }
        })
          .catch((err) => {
            prepostData.error = {
              error: err,
            };
          });
      }

      if (data.CEP && data.CEP.length < 8) {
        data.CEP = data.CEP.padStart(8, "0");
      }
      PostOfficeService.zipcode(data.CEP, "delivery")
        .then((res) => {
          if (res) {
            prepostData.prepost.delivery = {
              delivery: 1,
              branch: "",
              department: data.DEPARTAMENTO ? data.DEPARTAMENTO : "",
              cep: res.cep,
              contact: "",
              address: data.ENDERECO ? data.ENDERECO : res.end,
              neighborhood: data.BAIRRO ? data.BAIRRO : res.bairro,
              city: data.CIDADE ? data.CIDADE : res.cidade,
              state: data.UF ? data.UF : res.uf,
              number: data.NUMERO ? data.NUMERO : "",
              extent: data.COMPLEMENTO ? data.COMPLEMENTO : "",
              name: data.DESTINATARIO ? data.DESTINATARIO : "",
            };
          }
        })
        .catch((err) => {
          prepostData.error = {
            error: err,
          };
        });
      // CRIAÇÃO DA PRÉ-POSTAGEM

      prepostData.prepost.contact = {
        save: "",
        request: data.PEDIDO ? data.PEDIDO : "",
        invoice: data.NOTA ? data.NOTA : "",
        care: data.AC ? data.AC : "",
        mail: data.EMAIL_DESTINO ? data.EMAIL_DESTINO : "",
        phone: data.TELEFONE_DESTINO ? data.TELEFONE_DESTINO : "",
        federalid: data.CPF_CNPJ ? data.CPF_CNPJ : "",
      };

      prepostData.prepost.object = {
        package: data.EMBALAGEM ? data.EMBALAGEM : "",
        mdp: "",
        quantity: 1,
        reg: data.REGISTRADO ? data.REGISTRADO : "",
        urg: data.URGENTE ? data.URGENTE : "",
        weight: data.PESO,
        type: data.TIPO ? data.TIPO : "",
        object: data.OBJETO ? data.OBJETO : "",
      };

      prepostData.prepost.complement = {
        type: data.TIPO ? data.TIPO : "001",
        width: data.LARGURA ? +data.LARGURA : 0,
        height: data.ALTURA ? +data.ALTURA : 0,
        length: data.COMPRIMENTO ? +data.COMPRIMENTO : 0,
        value: data.VALOR_DECLARADO ? data.VALOR_DECLARADO : 0,
      };

      UploadService.getServiceData(data.SERVICO).then((res) => {
        if (!res) {
          prepostData.error = {
            error: `Serviço não localizado. LINHA ${index + 1}`,
          };
          return false;
        }
        prepostData.prepost.service = res.code;
      });

      prepostData.prepost.customer = vm.importForm.customer;

      Promise.all([prepostData])
        .then((res) => {
          vm.prepostList.push(res[0]);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    finish() {
      const vm = this;
      vm.active = 2;
    },

    save() {
      const vm = this;
      if (vm.value.length == 0) {
        this.$message({
          type: "error",
          message: "Selecione ao menos um campo para salvar o layout",
        });
        return false;
      }

      this.$prompt("Informe um nome para o layout", "Salvar", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputPlaceholder: "Informe um nome",
        inputErrorMessage: "É obrigatório informar um nome",

        inputValidator: function (v) {
          if (!v) {
            return false;
          }
        },
      })
        .then(async ({ value }) => {
          const loading = vm.$loading(vm.$options.loading);
          const data = {
            name: value,
            fields: vm.value,
            type: vm.$props.type,
          };

          await LayoutService.add(data)
            .then(async (response) => {
              vm.importForm.layouts.push(response);
              this.$message({
                type: "success",
                message: "Layout salvo com sucesso",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        })
        .catch(() => { });
    },

    async next() {
      const vm = this;
      if (vm.value.length > 0) {
        vm.importForm.fields = vm.value;
      }

      vm.active++;
    },

    back() {
      const vm = this;
      vm.active--;
      vm.error = {
        error: "",
        values: [],
      };
      //    vm.importForm.use = "";
      vm.value = [];
      vm.hasError = false;
      vm.isEqual = false;
      vm.mandatoryColumns = [];
      vm.importForm.layout = "";
      //      !vm.isCustomer ? (vm.importForm.customer = "") : "";
      vm.fileFields = "";
      vm.prepostList = [];
    },

    downloadSample() {
      window.open("/xpost/prepost-template.csv");
    },
  },
  computed: {
    isDisabled: function () {
      if (this.error.error !== "" || !this.hasFile) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      fileList: [],
      fileFields: "",
      fileData: [],
      me: {},
      importForm: {
        use: "",
        fields: "",
        layout: "",
        header: "1",
        layouts: [],
        started: [],
        customer: "",
        department: "",
      },
      filterMethod(query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      active: 0,
      value: [],
      customer: "",
      tableData: [
        {
          label: "CPF_CNPJ",
          key: "CPF_CNPJ",
          description: "CPF/CNPJ DO DESTINATÁRIO",
        },
        {
          label: "DESTINATARIO",
          key: "DESTINATARIO",
          description: "NOME DO DESTINATÁRIO",
        },
        {
          label: "EMPRESA",
          key: "EMPRESA",
          description: "EMPRESA RELACIONADA A ENTREGA AO DESTINATÁRIO",
        },
        {
          label: "DEPARTAMENTO",
          key: "DEPARTAMENTO",
          description: "DEPARTAMENTO RELACIONADO A PRÉ-POSTAGEM",
        },
        {
          label: "ENDERECO",
          key: "ENDERECO",
          description: "ENDEREÇO DO DESTINATÁRIO",
        },
        {
          label: "NUMERO",
          key: "NUMERO",
          description: "NÚMERO DO DESTINATÁRIO",
        },
        {
          label: "COMPLEMENTO",
          key: "COMPLEMENTO",
          description: "COMPLEMENTO DO ENDEREÇO DO DESTINATÁRIO",
        },
        {
          label: "BAIRRO",
          key: "BAIRRO",
          description: "BAIRRO DO DESTINATÁRIO",
        },
        {
          label: "CIDADE",
          key: "CIDADE",
          description: "CIDADE DO DESTINATÁRIO",
        },
        { label: "UF", key: "UF", description: "UF DO DESTINATÁRIO" },
        { label: "CEP", key: "CEP", description: "CEP DO DESTINATÁRIO" },
        {
          label: "TELEFONE_DESTINO",
          key: "TELEFONE_DESTINO",
          description: "TELEFONE DO DESTINATÁRIO",
        },
        {
          label: "EMAIL_DESTINO",
          key: "EMAIL_DESTINO",
          description: "EMAIL DO DESTINATÁRIO",
        },
        {
          label: "CPF_CNPJ_REM",
          key: "CPF_CNPJ_REM",
          description: "CPF/CNPJ DO REMETENTE",
        },
        {
          label: "NOME_REM",
          key: "NOME_REM",
          description: "NOME DO REMETENTE",
        },
        {
          label: "ENDERECO_REM",
          key: "ENDERECO_REM",
          description: "ENDERECO DO REMETENTE",
        },
        {
          label: "NUMERO_REM",
          key: "NUMERO_REM",
          description: "NÚMERO DO REMETENTE",
        },
        {
          label: "COMPLEMENTO_REM",
          key: "COMPLEMENTO_REM",
          description: "COMPLEMENTO DO REMETENTE",
        },
        {
          label: "BAIRRO_REM",
          key: "BAIRRO_REM",
          description: "BAIRRO DO REMETENTE",
        },
        {
          label: "CIDADE_REM",
          key: "CIDADE_REM",
          description: "CIDADE DO REMETENTE",
        },
        { label: "UF_REM", key: "UF_REM", description: "UF DO REMETENTE" },
        { label: "CEP_REM", key: "CEP_REM", description: "CEP DO REMETENTE" },
        { label: "OBJETO", key: "OBJETO", description: "NÚMERO DA ETIQUETA" },
        {
          label: "PRODUTO",
          key: "PRODUTO",
          description: "PRODUTO A SER ENVIADO AO DESTINATÁRIO",
        },
        {
          label: "EMBALAGEM",
          key: "EMBALAGEM",
          description: "EMBALAGEM UTILIZADA PARA O ENVIO AO DESTINATÁRIO",
        },
        {
          label: "TIPO",
          key: "TIPO",
          description: "TIPO DA EMBALAGEM :0-ENVELOPE E 1-PACOTE",
        },
        {
          label: "PESO",
          key: "PESO",
          description: "PESO DO OBJETO EM GRAMAS",
        },
        {
          label: "ALTURA",
          key: "ALTURA",
          description: "ALTURA DO OBJETO EM CENTÍMETROS",
        },
        {
          label: "LARGURA",
          key: "LARGURA",
          description: "LARGURA DO OBJETO EM CENTÍMETROS",
        },
        {
          label: "COMPRIMENTO",
          key: "COMPRIMENTO",
          description: "COMPRIMENTO DO OBJETO EM CENTÍMETROS",
        },
        {
          label: "DIAMETRO",
          key: "DIAMETRO",
          description: "DIÂMETRO DO OBJETO EM CENTÍMETROS",
        },
        {
          label: "SERVICO",
          key: "SERVICO",
          description: "CÓDIGO OU NOME DO SERVIÇO REFERENTE A PRÉ-POSTAGEM",
        },
        {
          label: "NOTA",
          key: "NOTA",
          description: "NÚMERO DA NOTA REFERENTE AO OBJETO",
        },
        {
          label: "PEDIDO",
          key: "PEDIDO",
          description: "NÚMERO DO PEDIDO REFERENTE AO OBJETO",
        },
        {
          label: "QTD",
          key: "QTD",
          description: "QUANTIDADE DE OBJETOS REFERENTES A NOTA",
        },
        {
          label: "VALOR_DECLARADO",
          key: "VALOR_DECLARADO",
          description: "VALOR DECLARADO REFERENTES AO OBJETO",
        },
        {
          label: "CONTRATO",
          key: "CONTRATO",
          description: "NÚMERO DO CONTRATO REFERENTE A PRÉ-POSTAGEM",
        },
        {
          label: "CARTAO",
          key: "CARTAO",
          description: "NÚMERO DO CARTÃO REFERENTE A PRÉ-POSTAGEM",
        },
        {
          label: "AC",
          key: "AC",
          description:
            "AOS CUIDADOS, REFERENTE A PESSOA QUE DEVERÁ RECEBER O OBJETO",
        },
        {
          label: "MP",
          key: "MP",
          description: "MÃO PRÓPRIA: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "AR",
          key: "AR",
          description:
            "AVISO DE RECEBIMENTO: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "URGENTE",
          key: "URGENTE",
          description: "URGENTE: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "REGISTRADO",
          key: "REGISTRADO",
          description: "REGISTRADO: 0 OU N PARA NÃO E 1 OU S PARA SIM",
        },
        {
          label: "MONITORAR",
          key: "MONITORAR",
          description:
            "MONITORAR: 0 OU N PARA NÃO E 1 OU S PARA SIM [VIA EMAIL/TELEFONE]",
        },
        {
          label: "OBSERVAÇÃO",
          key: "OBSERVACAO",
          description: "OBSERVAÇÃO SOBRE OBJETO OU PRÉ-POSTAGEM",
        },
        {
          label: "ESPAÇOS01",
          key: "ESPACOS01",
          description:
            "RELACIONADO A CAMPOS A SEREM DESCONSIDERADOS NA IMPORTAÇÃO",
        },
        {
          label: "ESPAÇOS02",
          key: "ESPACOS02",
        },
        {
          label: "ESPAÇOS03",
          key: "ESPACOS03",
        },
        {
          label: "ESPAÇOS04",
          key: "ESPACOS04",
        },
        {
          label: "ESPAÇOS05",
          key: "ESPACOS05",
        },
        {
          label: "ESPAÇOS06",
          key: "ESPACOS06",
        },
        {
          label: "ESPAÇOS07",
          key: "ESPACOS07",
        },
        {
          label: "ESPAÇOS08",
          key: "ESPACOS08",
        },
        {
          label: "ESPAÇOS09",
          key: "ESPACOS09",
        },
        {
          label: "ESPAÇOS10",
          key: "ESPACOS10",
        },
        {
          label: "ESPAÇOS11",
          key: "ESPACOS11",
        },
        {
          label: "ESPAÇOS12",
          key: "ESPACOS12",
        },
        {
          label: "ESPAÇOS13",
          key: "ESPACOS13",
        },
        {
          label: "ESPAÇOS14",
          key: "ESPACOS14",
        },
        {
          label: "ESPAÇOS15",
          key: "ESPACOS15",
        },
        {
          label: "ESPAÇOS16",
          key: "ESPACOS16",
        },
        {
          label: "ESPAÇOS17",
          key: "ESPACOS17",
        },
        {
          label: "ESPAÇOS18",
          key: "ESPACOS18",
        },
        {
          label: "ESPAÇOS19",
          key: "ESPACOS19",
        },
        {
          label: "ESPAÇOS20",
          key: "ESPACOS20",
        },
      ],
      error: {
        error: "",
        values: [],
      },
      hasError: false,
      hasFile: false,
      isEqual: false,
      mandatoryColumns: [],
      mandatoryProperties: ["CEP", "PESO", "SERVICO"],
      prepostList: [],
      isCustomer: false,
    };
  },
  async created() {
    const vm = this;
    vm.me = await UserService.me().catch((error) => {
      this.$message({
        type: "error",
        message: error,
      });
    });

    const myLayouts = await LayoutService.list();

    vm.importForm.layouts = myLayouts.records;

    vm.tableData = vm.tableData.sort((a, b) => a.label.localeCompare(b.label));

    if (vm.me.type === "2") {
      vm.importForm.customer = vm.me.customers.id;
      vm.isCustomer = true;
    }
  },
};
</script>

<style lang="scss">
.uploadWrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;

  .errorReport {
    .el-card__body {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 86%;
      background-color: #fef0f0;
      color: #f56c6c;

      span {
        align-self: center;
        margin-bottom: 15px;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: #eee;
    border-left: 1px solid #ccc;
  }

  ::-webkit-scrollbar-thumb:vertical,
  ::-webkit-scrollbar-thumb:horizontal {
    background-color: #a1a4a5;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:vertical:hover,
  ::-webkit-scrollbar-thumb:horizontal:hover {
    background-color: #717171;
  }
}

.el-transfer {
  .el-transfer-panel:last-child {
    .el-transfer-panel__list {
      height: calc(100% - 40px);
    }
  }
}

// 1. Validar Campos Obrigatórios
// 2. Disparar evento de pre-postagem
// 3. Comentar itens do menu
</style>
